export var securedTextFieldTheme = {
  baseStyle: _ref => {
    var {
      textVisible
    } = _ref;
    return {
      container: {
        // While this is a non-standard CSS property, it is supported by all major browsers, and is the only way to not show the password in the input field and also to not prompt the user to save the password.
        // https://caniuse.com/mdn-css_properties_-webkit-text-security
        WebkitTextSecurity: textVisible ? 'none' : 'disc'
      },
      inputRightIcon: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
      }
    };
  }
};
//# sourceMappingURL=SecuredTextField.theme.js.map